import { render } from "./TicketAttachments.vue?vue&type=template&id=dc94810c"
import script from "./TicketAttachments.vue?vue&type=script&lang=js"
export * from "./TicketAttachments.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__